import { render, staticRenderFns } from "./OriginEnterpriseComplaintList.vue?vue&type=template&id=0aa7b7a2&scoped=true"
import script from "./OriginEnterpriseComplaintList.vue?vue&type=script&lang=js"
export * from "./OriginEnterpriseComplaintList.vue?vue&type=script&lang=js"
import style0 from "./OriginEnterpriseComplaintList.vue?vue&type=style&index=0&id=0aa7b7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa7b7a2",
  null
  
)

export default component.exports